import type { Project } from './types';
import { projects } from './registry';

export function getAllProjects(): Project[] {
  return projects;
}

export function getAllProjectsSorted(): Project[] {
  return projects.sort((a, b) => {
    // Finished projects (non-placeholder) come first
    const aIsPlaceholder = a.ctaLabel === 'Still Classified';
    const bIsPlaceholder = b.ctaLabel === 'Still Classified';
    
    if (aIsPlaceholder !== bIsPlaceholder) {
      return aIsPlaceholder ? 1 : -1; // Finished projects (false) come before placeholders (true)
    }
    
    // Within same group, sort by date (earliest first)
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });
}

export function getProjectBySlug(slug: string): Project | null {
  return projects.find((project) => project.slug === slug) || null;
}

export function getPrevNext(slug: string): { prev: Project | null; next: Project | null } {
  const sortedProjects = getAllProjectsSorted();
  const currentIndex = sortedProjects.findIndex((p) => p.slug === slug);

  if (currentIndex === -1) {
    return { prev: null, next: null };
  }

  return {
    prev: currentIndex > 0 ? sortedProjects[currentIndex - 1] : null,
    next: currentIndex < sortedProjects.length - 1 ? sortedProjects[currentIndex + 1] : null,
  };
}

export function getAllSlugs(): string[] {
  return projects.map((project) => project.slug);
}